import React from 'react';
import Button from '../../Buttons/Button';
import {
  ContentContainer,
  AdminAvatar,
  MainContainer,
  Description,
  ButtonContainer,
  styles,
} from './styles';
import strings from '../../../../localization';
import { getCurrentTheme } from '../../../../templates';
import { Text } from '../../../ReusableComponents';

const Info = ({ onPress, params }) => {
  const currentTheme = getCurrentTheme();
  return (
    <ContentContainer>
      <AdminAvatar source={{ uri: 'round_logo' }} />
      <MainContainer>
        <Text
          style={[
            styles.title,
            {
              color: currentTheme.colors.secondaryLight,
            },
          ]}
          semiBold
        >
          {params.title}
        </Text>
        <Description>{params.description}</Description>

        <ButtonContainer>
          <Button withMarginRight title={strings.common.ok} onPress={onPress} />
          {params.onSubmit && (
            <Button
              title={strings.common.ok}
              onPress={() => {
                params.onSubmit();
                onPress();
              }}
            />
          )}
        </ButtonContainer>
      </MainContainer>
    </ContentContainer>
  );
};

export default Info;
